export default {"src":"/_next/static/media/img-bfy-2.083c56f7.svg","height":298,"width":397,"blurWidth":0,"blurHeight":0};